import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=3cb257c8&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=ts"
export * from "./receipt.vue?vue&type=script&lang=ts"
import style0 from "./receipt.vue?vue&type=style&index=0&id=3cb257c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb257c8",
  null
  
)

export default component.exports